<template>
  <div class="dashed-border p-3 mb-3">
    <div class="d-flex">
      <label class="mr-1" v-if="label">
        {{ label }}
      </label>
      <div class="flex-1"></div>
      <fb-field-config :field="field"></fb-field-config>
    </div>
    <img src="../../assets/images/image-upload.png" :style="imageStyle" />
  </div>
</template>

<script>
import { getSettings, ImagePrefix } from "../../assets/js/common.helper";
import FbFieldConfig from "./FbFieldConfig.vue";
import formMixins from "../../mixins/form.mixins";
export default {
  props: { field: {} },
  components: { FbFieldConfig },
  mixins: [formMixins],
  computed: {
    label() {
      return this.field.Form_Label;
    },
    src() {
      const vm = this;
      let image = getSettings({ ...vm.field }).image;
      return ImagePrefix + image;
    },
    data() {
      let data = getSettings({ ...this.field }).table_rows || [];
      return data;
    },
  },
};
</script>

<style></style>
